export const selectLaraThemeConfig = {
  colorScheme: {
    light: {
      focus: {
        ringShadow: "none",
        borderColor: "{primary-500}",
      },
      disabledBackground: "{gray-50}",
      disabledColor: "{gray-500}",
      borderRadius: "var(--radius-8)",
      borderColor: "{gray-300}",
      shadow: "var(--shadow-xs)",
      placeholderColor: "var(--p-gray-500)",
      optionSelectedBackground: "{gray-50}",
      optionPadding: "var(--spacing-8)",
      checkmarkColor: "{primary-600}",
    },
  },
  css: () => `
    .p-select:not(.p-disabled):not(.readonly).p-focus, .p-select-open {
      border: 2px solid var(--p-select-focus-border-color);
    }
    .p-select.readonly {
      background: var(--p-gray-50);
      span {
        color: var(--p-gray-500);
      }
    }
    .p-select:not(.p-disabled).p-focus.invalid-input, .p-select-open.invalid-input {
      border: 2px solid var(--p-red-500);
    }
   .p-select:not(.p-disabled):hover.invalid-input, .p-select.invalid-input {
      border-color: var(--p-red-300)
    }
    .p-select-sm .p-select-label {
      line-height: var(--line-height-text-24);
      font-weight: var(--font-weight-500);
    }
    .p-select-option {
      margin-inline: var(--spacing-6);
      margin-top: 5px;
      line-height: var(--line-height-text-24);
      border-radius: var(--radius-6);
      gap: var(--spacing-16);

      & > span {
        max-width: 95%;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .p-select-option .p-iconwrapper {
      order: 1;
      margin-inline-start: auto
    }
    .p-select-dropdown-icon {
      display: flex;
    }
    .p-select-label {
      width: auto;
    }
    .p-select-list {
      max-width: 100%;
    }
  `,
};
